import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PatientHistoryEntry } from '../data/patient-history-entry';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class PatientHistoryService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { }

  loadHistoryForBookToken(bookToken: string): Promise<PatientHistoryEntry[]> {
    return new Promise<PatientHistoryEntry[]>((resolve, reject) => {
      if (!environment.demo) {
        this.configService.BOOK_URL.then(confURL => {
          const url = `${confURL}/bookAccess/getHistoryByStudyToken?token=${bookToken}`;
          this.http.get<PatientHistoryEntry[]>(url, { withCredentials: true, responseType: 'json' }).subscribe(res => {
            resolve(PatientHistoryEntry.sanitizeAll(res));
          });
        }, error => reject(error))
      } else {
        resolve(PatientHistoryEntry.getExample())
      }
    });
  };

}
